import { render } from "./SearchDish.vue?vue&type=template&id=5d63945e"
import script from "./SearchDish.vue?vue&type=script&lang=js"
export * from "./SearchDish.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__